export const selectTenantsState = state => state.tenants;
export const selectAllTenants = state => state.tenants.tenants;
export const selectTenantLoading = state => state.tenants.loading;
export const selectTenantError = state => state.tenants.error;
